module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [(_vm.menu.children && _vm.menu.children.length === 1 && !_vm.menu.children[0].path) ? _c('el-menu-item', {
    key: _vm.menu.path,
    attrs: {
      "index": _vm.resolvePath('/', _vm.menu.path)
    }
  }, [(_vm.menu.meta.iconClass) ? _c('svg-icon', {
    staticClass: "icon",
    attrs: {
      "icon-class": _vm.menu.meta.iconClass
    }
  }) : _vm._e(), _vm._v("\n    " + _vm._s(_vm.menu.meta.title) + "\n  ")], 1) : (_vm.menu.children.length === 1 && _vm.menu.children[0].path) ? _c('el-submenu', {
    key: _vm.menu.path,
    attrs: {
      "index": _vm.menu.path,
      "hide-timeout": 100
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('svg-icon', {
    staticClass: "icon",
    attrs: {
      "icon-class": _vm.menu.meta.iconClass
    }
  }), _vm._v("\n      " + _vm._s(_vm.menu.meta.title) + "\n    ")], 1), _vm._v(" "), _vm._l((_vm.menu.children), function(submenu) {
    return _c('el-menu-item', {
      key: submenu.name,
      attrs: {
        "index": _vm.resolvePath(_vm.menu.path, submenu.path)
      }
    }, [_vm._v("\n      " + _vm._s(submenu.meta.title) + "\n    ")])
  })], 2) : (_vm.menu.children && _vm.menu.children.length >= 1) ? _c('el-submenu', {
    key: _vm.menu.path,
    attrs: {
      "index": _vm.menu.path,
      "hide-timeout": 100
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.menu.meta.iconClass) ? _c('svg-icon', {
    staticClass: "icon",
    attrs: {
      "icon-class": _vm.menu.meta.iconClass
    }
  }) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.menu.meta.title) + "\n    ")], 1), _vm._v(" "), _vm._l((_vm.menu.children), function(submenu) {
    return _c('el-menu-item', {
      key: submenu.name,
      attrs: {
        "index": _vm.resolvePath(_vm.menu.path, submenu.path)
      }
    }, [_vm._v("\n      " + _vm._s(submenu.meta.title) + "\n    ")])
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5577c214","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar/SidebarItem.vue
// module id = C6j+
// module chunks = 3